/**
 * @fileoverview Utilitário para persistência local de dados críticos (favoritos e carrinho).
 * Implementa fallback para quando WebSocket/sessão falha em dispositivos móveis.
 * 
 * @module LocalStorage
 * @since 1.0.0
 */

const STORAGE_KEYS = {
  FAVORITES: 'vikanaweb_favorites',
  CART: 'vikanaweb_cart',
  LAST_SYNC: 'vikanaweb_last_sync'
};

/**
 * Utilitário para gerenciar persistência local de dados.
 */
export const persistData = {
  /**
   * Salva favoritos no localStorage.
   * @param {Array} favorites - Lista de favoritos
   */
  saveFavorites: (favorites) => {
    try {
      localStorage.setItem(STORAGE_KEYS.FAVORITES, JSON.stringify(favorites));
      localStorage.setItem(STORAGE_KEYS.LAST_SYNC, new Date().toISOString());
    } catch (error) {
      console.warn('Erro ao salvar favoritos localmente:', error);
    }
  },

  /**
   * Carrega favoritos do localStorage.
   * @returns {Array} Lista de favoritos
   */
  loadFavorites: () => {
    try {
      const data = localStorage.getItem(STORAGE_KEYS.FAVORITES);
      return data ? JSON.parse(data) : [];
    } catch (error) {
      console.warn('Erro ao carregar favoritos localmente:', error);
      return [];
    }
  },

  /**
   * Salva carrinho no localStorage.
   * @param {Array} cart - Itens do carrinho
   */
  saveCart: (cart) => {
    try {
      localStorage.setItem(STORAGE_KEYS.CART, JSON.stringify(cart));
      localStorage.setItem(STORAGE_KEYS.LAST_SYNC, new Date().toISOString());
    } catch (error) {
      console.warn('Erro ao salvar carrinho localmente:', error);
    }
  },

  /**
   * Carrega carrinho do localStorage.
   * @returns {Array} Itens do carrinho
   */
  loadCart: () => {
    try {
      const data = localStorage.getItem(STORAGE_KEYS.CART);
      return data ? JSON.parse(data) : [];
    } catch (error) {
      console.warn('Erro ao carregar carrinho localmente:', error);
      return [];
    }
  },

  /**
   * Limpa todos os dados locais.
   */
  clearAll: () => {
    try {
      Object.values(STORAGE_KEYS).forEach(key => {
        localStorage.removeItem(key);
      });
    } catch (error) {
      console.warn('Erro ao limpar dados locais:', error);
    }
  },

  /**
   * Verifica se há dados locais salvos.
   * @returns {boolean}
   */
  hasLocalData: () => {
    return localStorage.getItem(STORAGE_KEYS.FAVORITES) !== null || 
           localStorage.getItem(STORAGE_KEYS.CART) !== null;
  }
};

export default persistData;